import styled, { css } from 'styled-components';
import { ml, py } from '@lendi-ui/spacing';
import { display } from '@lendi-ui/utils';
import { BUTTON_STATUS } from '@funnels/constants';

export const OnlyVisibleOnMobileAndTablet = styled.div`
  ${display({ mobile: 'flex', desktop: 'none' })}
`;

export const OnlyVisibleOnDesktop = styled.div`
  ${display({ mobile: 'none', desktop: 'flex' })}
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  & > button {
    width: 188px;
    ${ml('xxs')}
  }
`;

export const StatusTextWrapper = styled.div<{ buttonStatus: BUTTON_STATUS }>`
  display: flex;
  justify-content: center;
  font-style: italic;
  ${py('xxxs')};
`;
